// COORDINATE 一覧
class coordinateListAC {
  constructor($t,prm,pager=1,limit=40){
    this.defaults={
      folder:'snap',
      prm:prm,
      keys:[
        'product_number'
      ],
      limit:limit,
      pager:pager,
      pager_range:4
    };
    this.op=this.defaults;
    this.$t=$t;
    this.$content=this.$t.closest('.ac-content');
    this.snapPrm={
      apikey:GN_AC.key,
      with:'relating_staff',
      using_to_product_number:this.op.prm.product_number,
      limit:this.op.limit,
      start:(this.op.pager-1)*this.op.limit
    };
    this.pager=this.op.pager;
    this._loadList();
  };
  _loadList=()=>{
    let arg=acArgument.response(this.snapPrm,this.op.folder);
    fetchJsonp(arg).then((data)=>{
      return data.json();
    }).then((data)=>{
      let items=data['data'];
      let len=items.length;
      let elm=String();
      if(len){
        for(let i=0;i<len;i++){
          let item=items[i];
          let o={
            id:item['id'],
            image:item['image_url_m'],
            date:item['date'],
            title:item['title'],
            shop_id:item['shop_id'],
            shop_name:item['shop_name'],
            shortid:item['shortid'],
            brand_id:item['brand_id'],
            brand_name:item['brand_name'],
            staff:{
              id:item['staff_id'],
              image:item['staff_image'],
              name:{
                first:item['staff_first_name'],
                last:item['staff_last_name']
              },
              height:item['staff_height']
            }
          };
          let permalink={
            snap:`${SnapFiles.detail}?brand=${o.brand_id}&shop=${o.shop_id}&staff=${o.staff.id}&snap=${o.id}`,
            staff:`${SnapFiles.staff}?brand=${o.brand_id}&shop=${o.shop_id}&staff=${o.staff.id}`
          };
          let staff_name='';
          staff_name=(o.staff.name.last)?o.staff.name.last:'';
          staff_name+=(o.staff.name.first)?o.staff.name.first:'';
          elm+=String()
            +'<li>'
              +((o.image)?'<div class="photo"><a href="'+permalink.snap+'"><img class="object-fit-img" src="'+o.image+'" alt="'+o.title+'"></a></div>':'')
              +'<div class="staff">'
                +((o.staff.image)?'<div class="photo"><a href="'+permalink.staff+'"><img class="object-fit-img" src="'+o.staff.image+'" alt="'+staff_name+'の写真"></a></div>':'')
                +'<div class="info">'
                  +((o.brand_name)?'<p class="text brand">'+o.brand_name+'</p>':'')
                  +((o.shop_name)?'<p class="text shop">'+o.shop_name+'</p>':'')
                  +'<p class="text name"><a href="'+permalink.staff+'">'+staff_name+'</a></p>'
                  +((o.staff.height)?'<p class="text height">'+o.staff.height+'cm</p>':'')
                +'</div>'
              +'</div>'
            +'</li>'
          ;
        };
        this.$t.insertAdjacentHTML('beforeend',elm);

        this.snapPrm.limit=this.op.limit*this.op.pager_range;
        this.snapPrm.start=this.pager*this.op.limit;
        let pagerArg=acArgument.response(this.snapPrm,this.op.folder);
        fetchJsonp(pagerArg).then((pager_data)=>{
          return pager_data.json();
        }).then((pager_data)=>{
          let pager_items=pager_data['data'];
          let pager_len=pager_items.length;
          if(this.pager>1||pager_len){
            let pages=Math.ceil(pager_len/this.op.limit);
            let pagerLinkArr=[];
            if(this.op.prm){
              for(let i in this.op.prm){
                if(this.op.prm[i]!=undefined){
                  if(this.op.keys.indexOf(i)>-1){
                    pagerLinkArr[i]=this.op.prm[i];
                  };
                };
              };
            };
            let $pager_elm=acPagination(pages,this.pager,this.op.pager_range,SnapFiles.list,pagerLinkArr,this.op.limit,len);
            this.$content.insertAdjacentHTML('beforeend',$pager_elm);
          };
        });
      };
    });
  };
};

let prm={
  pager:prmArr['pager'],
  product_number:prmArr['product_number']
};
prm.pager=(prm.pager)?new Number(prm.pager):prm.pager;
let $acCoordinateResults=document.querySelector('.ac-coordinate-results');
if($acCoordinateResults){
  const $acCoordinateResultsLists=$acCoordinateResults.querySelector('.ac-snap-lists');
  if($acCoordinateResultsLists&&prm.product_number){
    let limit=$acCoordinateResultsLists.getAttribute('data-ac-limit');
    limit=(limit)?limit:40;
    let coordinatePrm={
      product_number:prm.product_number
    };
    let pager=prm.pager;
    new coordinateListAC($acCoordinateResultsLists,coordinatePrm,pager,limit);
  };
};